<template>
    <div class="app-container" style="background-color: #f9fbff;">
        <div class="review-title-content">
            <div class="reasons-title">
                <h3>チカラもちの口コミ</h3>
            </div>
        </div>
        <div class="card">
            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">
                    ネットでチカラもちを見つけ、Webフォームで問合せ後、1時間もせず、連絡が入り、設置状況の写真撮影を細かくご指示いただき、メール送信したところ、1時間少しで見積りをいただく。
                </p>
                <p class="review-content-text">
                    家族で相談し、<span class="under-yellow">出来るだけ早くに設置依頼したところ、翌日午後からの工事となり、とても助かりました。</span>
                </p>
                <p class="review-content-text">
                    工事の手際、後片付けの美しさ、近隣への工事前挨拶、<span class="under-yellow">全て、要領を得ていて、安心して任せられるお店でした。</span>
                </p>
                <p class="review-content-text">
                    一番寒い週に迅速に対応してもらえたので、本当に助かりました。有難うございました。
                </p>
                <p class="google-review">引用：Google口コミ</p>
            </div>

            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">
                   チカラもち奈良店さんで給湯器の入れ替えしました。
                </p>
                <p class="review-content-text">
                    <span class="under-yellow">圧倒的な価格の安さで追加料金などあるのかなぁと思ってましたが、追加費用一切無しでした。</span>
                </p>
                <p class="review-content-text">
                    また、とても感じの良い担当者さんで、手際良く交換して下さいました。
                </p>
                <p class="review-content-text">
                    室内に入る際の声掛けや取り扱い説明なども感じ良く、もちろん工事も丁寧でした。
                </p>
                <p class="google-review">引用：Google口コミ</p>
            </div>

            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">
                    設置担当の方は丁寧かつ親切で、本当に助かりました。
                </p>
                <p class="review-content-text">
                    <span class="under-yellow">ネットでの購入は不安でしたが、安心して任せると思います。</span>
                </p>
                <p class="review-content-text">
                    <span class="under-yellow">値段も他の量販店なりよりかなり安く、おすすめです。</span>実家の給湯器も考えます。
                </p>
                <p class="google-review">引用：Google口コミ</p>
            </div>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
.app-container {
    background: #f9fbff;
    padding: 40px 20px;
}

.reasons-title {
    margin-bottom: 30px;
    text-align: center;
}

.reasons-title h3 {
    font-size: 32px;
    font-weight: 800;
    margin: 0;
    line-height: 1.2;
    background: linear-gradient(90deg, #3f51b5, #3F51B5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    display: inline-block;
    padding-bottom: 10px;
}

.reasons-title h3::after {
    content: "";
    display: block;
    width: 80px;
    height: 4px;
    background: #3f51b5;
    margin: 12px auto 0;
    border-radius: 2px;
}

.card {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.review-content {
    background: #fff;
    padding: 25px 20px;
    border: 1px solid #eee;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    text-align: left;
}

.review-header {
    margin-bottom: 12px;
}

.rating-point-box {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #555;
}

.rating-stars {
    color: #ffc107;
    font-size: 18px;
    letter-spacing: 2px;
}

.rating-score {
    font-size: 18px;
    font-weight: bold;
    color: #d9534f;
}

.google-review {
    text-align: right;
    font-size: 12px;
    padding-bottom: 0;
    margin-bottom: 0;
}

.review-header img {
    width: 60px;
    height: auto;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .review-content-text {
        font-size: 0.9rem;
    }

    .google-review {
        font-size: 0.7rem;
    }

    .rating-point-box img {
        width: 20%;
    }

    .rating-stars,
    .rating-score {
        font-size: 0.9rem;
    }

    .reasons-title h3 {
        font-size: 1.5rem
    }

    .rating-stars {
        font-size: 1.2rem;
    }
}
</style>
